import styled from 'styled-components';

export const Container = styled.div`
  a {
    color: inherit;
    text-decoration: underline;
  }
`;
